import { sendApiCall } from "../../utilities/api";
import { authorizeUserForApi } from "../../utilities/api.userauth";
import { getTranslations } from "../../translations";
import { sendDataLayer } from "../../components/ecommerce/ecommerce";
import { loaderIconButton, resetLoaderButton } from "../../utilities/loaderIconButton";
import { Popup, PopupPosition } from "../../utilities/popup";
import { showNotification } from "../../utilities/notification";

declare const UIkit: any;

// Added by Recaptcha.cs.
declare const triggerRecaptchaCallBack: any;
declare const recaptchaList: any;

// TODO: Remove these once properly implemented.
const initCartMergePopup = (window as any).initCartMergePopup;
const setStickyLogin = (window as any).setStickyLogin;
const resetButton = (window as any).resetButton;
const setLoginPopupEvents = (window as any).setLoginPopupEvents;

function asyncLoginClick(
    sender: any,
    fromPopup: boolean,
    fromCart: boolean,
    redirectpath?: string | null
): void
{
    if ($(sender).find("[name=g-recaptcha-response]").length === 0 ||
        ($(sender).find("[name=g-recaptcha-response]").val() as string).length > 0)
    {
        let checkMergeCart = true;

        // Do not check merge cart if for cart or if there's a redirect.
        if (fromCart || (redirectpath && redirectpath.length > 0))
            checkMergeCart = false;

        const formData = new FormData($(sender)[0]);
        formData.append("checkmergecart", String(checkMergeCart));

        const email = formData.get("email");
        const password = formData.get("password");

        $(".js-loginform__form .js-messageblock--error").empty();
        $("#loginModal form .field_error").removeClass("field_error");

        $.ajax({
            type: "POST",
            url: "/Services/Modules/Webshop.asmx/LoginUser",
            dataType: "json",
            data: formData,
            enctype: "multipart/form-data",
            processData: false,
            contentType: false,
            complete: function (data: { responseJSON?: any | null })
            {
                resetLoaderButton($(sender).find(".btn-loader.is-loading")[0]);

                if (data && data.responseJSON)
                {
                    if (fromPopup)
                    {
                        // TODO: Classes.
                        if (data.responseJSON.Template.length > 0)
                        {
                            $("#loginModal .uk-modal-dialog .modal-content .loginDiv").replaceWith($(data.responseJSON.Template).find(".uk-modal-dialog .modal-content .loginDiv"));

                            if (setLoginPopupEvents)
                            {
                                setTimeout(function ()
                                {
                                    setLoginPopupEvents();
                                }, 1);
                            }
                        }
                    }
                    else if ($("[name='customerlogin']").length > 0 && typeof triggerRecaptchaCallBack !== "undefined")
                    {
                        for (let i = 0; i < recaptchaList.length; i++)
                            triggerRecaptchaCallBack(i);
                    }


                    let hasErrors = false;
                    let hasCartMergePopup = false;
                    let logoutLink = "";

                    // Get current modal and ID.
                    let errorHolder: any = "";
                    let senderError: any = "";
                    let modal: any = "";
                    let modalID = "";

                    if (fromPopup)
                    {
                        // TODO: Classes.
                        if ($("#favoritelist-add-popup:visible").length > 0)
                        {
                            errorHolder = $("#favoritelist-add-popup .error-messages");
                            senderError = $("#favoritelist-add-popup form");
                        }
                        else
                        {
                            errorHolder = $("#loginModal .error-messages");
                            senderError = $("#loginModal form");
                        }

                        modal = $("#loginModal");

                        if (modal && $(modal)[0])
                            modalID = $(modal)[0].id;
                    }
                    else
                    {
                        errorHolder = $(".js-loginform .js-messageblock--error");
                        senderError = $(".customer-login .js-loginform__form");
                    }

                    let loginRedirectSubPage = false;
                    let loginRedirectURL: string | null = null;

                    if (data.responseJSON.Messages.length > 0)
                    {
                        $.each(data.responseJSON.Messages, function (index: number, item: any)
                        {
                            // #region Redirects

                            // Loginredirect contains the URL to redirect to. Used to redirect if user logged in while on the login page.
                            if (item.Key === "loginredirect")
                            {
                                // Don't redirect if not for popup, as it will be handled later.
                                if (!fromPopup)
                                {
                                    loginRedirectURL = item.Message;
                                    return false;
                                }
                                else
                                {
                                    window.location.href = item.Message;
                                    return;
                                }
                            }

                            // Redirectpath contains the URL to redirect to if account did not fully finish registration.
                            if (item.Key === "redirectpath")
                            {
                                // Don't redirect if not for popup, as it will be handled later.
                                if (!fromPopup)
                                    return false;
                                else
                                {
                                    window.location.href = item.Message;
                                    return;
                                }
                            }

                            // #endregion Redirects

                            // Cart popup is not an error, but the merge cart popup.
                            if (item.Key === "cartpopup" && !fromCart)
                            {
                                hasCartMergePopup = true;

                                // Append merge cart popup template.
                                // TODO: Classes.
                                $(".cart-merge-popup").remove();
                                $(".js-header-topbar").append(item.Message); // TODO: Is this still correct?
                            }
                            // Logout link is not an error, but the logout link template.
                            else if (item.Key === "logoutlink")
                                logoutLink = item.Message;
                            // Whether the login redirect (if present) is an account subpage.
                            else if (item.Key === "loginredirectsubpage")
                            {
                                if (item.Message.toLowerCase() === "true")
                                    loginRedirectSubPage = true;
                            }
                            // Magic link contains more than just error message.
                            else if (item.Key === "magiclink")
                            {
                                // Clear previous errors.
                                if (!hasErrors)
                                {
                                    $(errorHolder).empty();
                                    $(senderError).find(".field_error").removeClass("field_error");
                                }

                                hasErrors = true;
                                $(errorHolder).addClass("error-magic");
                                $(sender).find("[name=" + item.Key + "]").addClass("field_error");
                                $(errorHolder).append(item.Message);

                                // Get error message from rendered magiclink template.
                                let errorMessage = item.Message.substring(item.Message.indexOf("<span>") + 6, item.Message.indexOf("</span>"));
                                if (!errorMessage || errorMessage.length <= 0)
                                    errorMessage = "De combinatie van e-mailadres en wachtwoord is incorrect.";

                                sendDataLayer({
                                    "event": "Error",
                                    "category": "Login",
                                    "action": document.location.pathname,
                                    "label": errorMessage
                                });
                            }
                            // Normal errors.
                            else
                            {
                                // Clear previous errors.
                                if (!hasErrors)
                                {
                                    $(errorHolder).empty();
                                    $(errorHolder).removeClass("error-magic");
                                    $(senderError).find(".field_error").removeClass("field_error");
                                }

                                hasErrors = true;

                                $(sender).find("[name=" + item.Key + "]").addClass("field_error");
                                $(errorHolder).append(item.Message);

                                // Remove line break at the end of the error message.
                                const errorMessage = item.Message.replace(/<br \/>/g, "");

                                sendDataLayer({
                                    "event": "Error",
                                    "category": "Login",
                                    "action": document.location.pathname,
                                    "label": errorMessage
                                });
                            }
                        });

                        // Set magiclink events.    
                        initMagicLink();
                    }

                    if (!hasErrors)
                    {
                        const callbackFunction = function (): void
                        {
                            if (fromPopup)
                            {
                                // No errors means login was successful, so hide the modal.
                                if (modalID && modalID.length > 0)
                                {
                                    // TODO: Classes.
                                    UIkit.modal("#" + modalID).hide();
                                    UIkit.modal("#favoritelist-add-popup").hide();
                                }

                                // Set logout link content where login button was.
                                if (logoutLink && logoutLink.length > 0)
                                    $(".js-header-links").replaceWith(logoutLink); // TODO: Is this still correct?

                                // Check whether to show merge cart popup.
                                if (hasCartMergePopup)
                                    initCartMergePopup();

                                setTimeout(function ()
                                {
                                    setStickyLogin();
                                }, 1);
                            }
                            else
                            {
                                // When redirect URL is for account subpage, go there instead.
                                if (!fromCart &&
                                    loginRedirectSubPage &&
                                    loginRedirectURL &&
                                    loginRedirectURL.length > 0
                                )
                                    window.location.href = loginRedirectURL;
                                else if (redirectpath)
                                {
                                    // Replace instead of using href to prevent login being in page history.
                                    if (fromCart)
                                        window.location.replace(redirectpath);
                                    else
                                        window.location.href = redirectpath;
                                }
                            }
                        };

                        authorizeUserForApi(email, password, callbackFunction);
                    }
                    // If not for popup, ensure error classes are present.
                    else if (!fromPopup)
                        $(errorHolder).addClass("c-error-messages");
                }
            }
        });
    }
}

(window as any).asyncLoginClick = asyncLoginClick;

//#region Address

function getAddressCustomer(overwrite: boolean): void
{
    if (($("#zipcode").val() as string).length > 0 &&
        ($("#number").val() as string).length > 0 &&
        (overwrite || ($("#street").val() as string).length === 0))
    {
        $.ajax({
            type: "POST",
            url: "/Services/Util.asmx/AutoCompleteAddress",
            data: { zipcode: $("#zipcode").val(), number: $("#number").val(), country: $("#country").val() },
            dataType: "json",
            success: function (result: any)
            {
                if ($(result) != null)
                {
                    if (($("#country").val() as string).toLowerCase() === "nl")
                        $("#hidden_street, #street").val(result.street);

                    const addressResults = result;

                    if (addressResults.length > 1)
                    {
                        $("#residence_select option").addClass("old");

                        let selectedOption = false;

                        $.each(addressResults, function (i, addressResult)
                        {
                            var cityText = $(addressResult).find("city").text().toUpperCase();

                            if (cityText === $("#hidden_residence").val())
                                selectedOption = true;

                            $("<option />")
                                .prop("value", cityText)
                                .prop("selected", cityText === $("#hidden_residence").val())
                                .text(cityText)
                                .appendTo($("#residence_select"));
                        });

                        $("#residence_select option.old").remove();

                        $("#residence").val("").prop("disabled", true).hide();
                        $("#residence_select").removeProp("disabled").show();

                        if (!selectedOption)
                            $("#hidden_residence").val($("#residence_select option:first").val() as string);
                    }
                    else
                    {
                        $("#hidden_residence, #residence").val(result.city);

                        $("#residence_select").val("").prop("disabled", true).hide();
                        $("#residence").removeProp("disabled").show();
                    }

                    if (($("#country").val() as string).toLowerCase() === "nl")
                    {
                        $("#street, #residence").removeAttr("readonly").css({
                            "background-color": "White",
                            "border": "1px solid #ABADB3"
                        });
                    }
                    else if (($("#country").val() as string).toLowerCase() === "be")
                    {
                        $("#residence").removeAttr("readonly").css({
                            "background-color": "White",
                            "border": "1px solid #ABADB3"
                        });
                    }

                    setZipCheckMessage();
                }
                else
                {
                    $("#residence_select").val("").prop("disabled", true).hide();
                    $("#residence").removeProp("disabled").show();
                    $("#hidden_residence").val($("#residence").val() as string);

                    $("#street, #residence")
                        .removeAttr("readonly")
                        .removeAttr("tabstop")
                        .css({
                            "background-color": "White",
                            "border": "1px solid #ABADB3"
                        });

                    setZipCheckMessage();
                }
            }
        });
    }
}


(window as any).getAddressCustomer = getAddressCustomer;

//#region Zipcode

function setZipcodeEventsCustomer(): void
{
    $("#zipcode, #number").on("blur", function (event)
    {
        if ((event.target as HTMLElement).id === "zipcode")
            formatCustomerZipCode();

        if (($("#country").val() as string).toLowerCase() === "nl")
            getAddressCustomer(false);
        else
            getAddressCustomer(true);
    });

    $("#check_address").on("click", function ()
    {
        getAddressCustomer(true);
    }).show();

    $("input[name='zipcode']").on("input", function ()
    {
        if ($("input[name='number']").val() !== "")
            $(".js-street-residence").removeClass("hidden");
    });

    $("input[name='number']").on("input", function ()
    {
        if ($("input[name='zipcode']").val() !== "")
            $(".js-street-residence").removeClass("hidden");
    });

    $("#zipcode, #housenumber").on("keyup", function ()
    {
        formatCustomerZipCode();

        if (($("#country").val() as string).toLowerCase() === "be")
            $("#residence").val("");
        else
            $("#street, #residence").val("");

        $("#street, #residence")
            .removeAttr("readonly")
            .removeAttr("tabstop")
            .css({
                "background-color": "White",
                "border": "1px solid #ABADB3"
            });
    });
}

function setZipCheckMessage(): void
{
    let mess = "";

    if (($("#street").val() as string).length === 0 &&
        $("#errors").length > 0 &&
        ($("#errors").html() as string).indexOf("Er is geen straat ingevuld.") === -1
    )
        mess = "Er is geen straat ingevuld.<br />";

    if (((!$("#residence").prop("disabled") &&
        ($("#residence").val() as string).length === 0) &&
        !$("#residence_select").prop("disabled")) &&
        ($("#errors").html() as string).indexOf("Er is geen plaats ingevuld.") === -1
    )
        mess += "Er is geen plaats ingevuld.<br />";

    $("#zipcode_errors").empty();

    if (mess.length > 0)
    {
        $("#zipcode_errors").html(mess);

        // Remove excess br's.
        const errorHtml = ($("#errors").html() as string).replaceAll("<br><br>", "<br/>");
        $("#errors").html(errorHtml);
    }
    else
    {
        if (($("#street").val() as string).length > 0 &&
            ($("#residence").val() as string).length > 0)
        {
            const cleanHtml = ($("#errors").html() as string)
                .replace("Er is geen straat ingevuld.", "")
                .replace("Er is geen plaats ingevuld.", "")
                .replaceAll("<br><br>", "<br/>");

            $("#errors").html(cleanHtml);
        }
    }
}

function removeZipcodeEvents(): void
{
    $("#zipcode, #number, #housenumber").off();
    $("#check_address").off().hide();
}

function formatCustomerZipCode(): void
{
    if ($("#country").length > 0 &&
        $("#country").val() != null &&
        $("#country").val() === "NL" &&
        ($("#zipcode").val() as string).length > 0 &&
        ($("#zipcode").val() as string).length >= 6)
    {
        const formattedZip =
            ($("#zipcode").val() as string).substring(0, 4).trim() +
            " " +
            ($("#zipcode").val() as string).substring(4, ($("#zipcode").val() as string).length).trim();

        $("#zipcode").val(formattedZip);
    }
}

(window as any).setZipcodeEventsCustomer = setZipcodeEventsCustomer;
(window as any).setZipCheckMessage = setZipCheckMessage;
(window as any).removeZipcodeEvents = removeZipcodeEvents;
(window as any).formatCustomerZipCode = formatCustomerZipCode;

//#endregion Zipcode

//#region Country

function handleCountryChange(): void
{
    const selCountry = ($("#country").val() as string).toLowerCase();

    if (($("input[name='zipcode']").val() as string).length > 0 && ($("input[name='number']").val() as string).length > 0 || selCountry !== "nl")
        $(".js-street-residence").removeClass("hidden");
    else
        $(".js-street-residence").addClass("hidden");

    if (selCountry.toLowerCase() !== "nl" &&
        selCountry.toLowerCase() !== "be")
    {
        $("#street, #residence").removeAttr("readonly").css({
            "background-color": "White",
            "border": "1px solid #ABADB3",
            "color": "Black"
        });
    }
    else
    {
        setZipcodeEventsCustomer();
        getAddressCustomer(true);
    }

    if (selCountry === "be")
        $(".w-register-form__zipcode-housenumber").addClass("show-bus");
    else
        $(".w-register-form__zipcode-housenumber").removeClass("show-bus");
}

(window as any).handleCountryChange = handleCountryChange;

//#endregion Country

//#endregion Address

//#region Register preferences

export class RegisterPreferences
{
    private form: HTMLFormElement;
    private questions: HTMLElement[];
    private nextButton: HTMLButtonElement | null;
    private submitButton: HTMLButtonElement | null;
    private currentIndex: number = 0;

    constructor(form: HTMLFormElement)
    {
        this.form = form;

        this.questions = Array.from(
            this.form.querySelectorAll<HTMLElement>(".c-interestquestion")
        );

        this.nextButton = this.form.querySelector<HTMLButtonElement>(
            ".w-register-form__question-continue"
        );

        this.submitButton = this.form.querySelector<HTMLButtonElement>(
            ".w-register-form__question-submit"
        );

        this.init();
    }

    private init(): void
    {
        if (this.questions.length === 0)
            return;

        this.setupQuestions();
        this.attachEvents();
        this.updateButtons();
    }

    private setupQuestions(): void
    {
        this.questions.forEach((question, index) =>
        {
            if (index === 0)
                this.showQuestion(question);
            else
                this.hideQuestion(question);
        });
    }

    private attachEvents(): void
    {
        this.nextButton?.addEventListener("click", () =>
        {
            this.showNextQuestion();
        });
    }

    private showNextQuestion(): void
    {
        const currentQuestion = this.questions[this.currentIndex];

        if (!currentQuestion)
            return;

        this.hideQuestion(currentQuestion);

        this.currentIndex++;

        const nextQuestion = this.questions[this.currentIndex];

        if (nextQuestion)
            this.showQuestion(nextQuestion);

        this.updateButtons();
    }

    private showQuestion(question: HTMLElement): void
    {
        question.classList.remove("hidden");

        this.openAccordion(question);
    }

    private hideQuestion(question: HTMLElement): void
    {
        question.classList.add("hidden");
    }

    private openAccordion(question: HTMLElement): void
    {
        const toggle = question.querySelector<HTMLElement>(
            ".js-accordion__toggle"
        );

        if (!toggle)
            return;

        const isOpen =
            toggle.getAttribute("aria-expanded") === "true";

        if (!isOpen)
            toggle.click();
    }

    private updateButtons(): void
    {
        const isLastQuestion =
            this.currentIndex >= this.questions.length - 1;

        this.nextButton?.classList.toggle(
            "hidden",
            isLastQuestion
        );

        this.submitButton?.classList.toggle(
            "hidden",
            !isLastQuestion
        );
    }
}

$(() =>
{
    document
        .querySelectorAll<HTMLFormElement>(
            ".w-register-form__form"
        )
        .forEach((form) =>
        {
            if (form.querySelector(".c-interestquestion"))
                new RegisterPreferences(form);
        });
});

//#endregion Register preferences

//#region Forgot password

let forgotPasswordPopup: Popup;
let alreadySent: boolean = false;

export const forgotPasswordClick = (): void =>
{
    if (alreadySent)
    {
        showNotification({
            message: "Er is al een poging gedaan om een wachtwoord te herstellen",
            status: "warning"
        });

        return;
    }

    if (forgotPasswordPopup === undefined) createPopup();

    forgotPasswordPopup.show();
}

const createPopup = () =>
{
    const form = document.createElement("form");
    form.setAttribute("name", "resetPassword");
    form.setAttribute("action", "");
    form.setAttribute("method", "post");
    form.setAttribute("onsubmit", "resetPasswordNew(event); return false;")
    form.setAttribute("id", "reset-form");
    form.classList.add("w-loginform__forgot-password-form");

    const hiddenInput = document.createElement("input");
    hiddenInput.name = "reset-password";
    hiddenInput.value = "1";
    hiddenInput.type = "hidden";
    form.appendChild(hiddenInput);

    const inputHolder = document.createElement("div");
    inputHolder.classList.add("u-text-holder");

    const emailLabel = document.createElement("label");
    emailLabel.innerText = getTranslations().emailTxt;
    emailLabel.setAttribute("for", "reset-email");

    const emailField = document.createElement("input");
    emailField.setAttribute("type", "email");
    emailField.setAttribute("id", "reset-email");
    emailField.setAttribute("name", "email");
    emailField.setAttribute("value", "");
    emailField.setAttribute("autofocus", "");
    emailField.setAttribute("required", "");
    emailField.classList.add("js-validation");

    const submitButton = document.createElement("button");
    submitButton.innerHTML = getTranslations().txtResetPassword;
    submitButton.classList.add("btn", "btn-green", "btn-arrow-right", "full-width");
    submitButton.setAttribute("onclick", "resetPasswordNew()");

    inputHolder.appendChild(emailLabel);
    inputHolder.appendChild(emailField);
    form.appendChild(inputHolder);
    form.appendChild(submitButton);

    forgotPasswordPopup = new Popup({
        title: getTranslations().forgottenPasswordTxt,
        mobilePosition: PopupPosition.Drawer,
        desktopPosition: PopupPosition.Right,
        closeButton: true,
        content: form,
    });
}


export const resetPasswordNew = (event) =>
{
    event.preventDefault();
    event.stopPropagation();

    const form = document.getElementById("reset-form") as HTMLFormElement;

    if (form)
    {

        if (!alreadySent)
        {
            alreadySent = true;
            $.ajax({
                type: "POST",
                url: "/Services/Modules/Webshop.asmx/ResetPassword",
                data: new FormData(form),
                dataType: "html",
                enctype: "multipart/form-data",
                processData: false,
                contentType: false,
                success: function (data)
                {
                    $("#reset-form").html($(data).find("#reset-form").html());

                    if ($("#reset-form .error-messages").length == 0)
                        $("#reset-form .forgot-password input#reset-mail").parent().hide();

                    forgotPasswordPopup.hide();

                    showNotification({
                        message: getTranslations().forgottenPasswordEmailSendTxt,
                        status: "success"
                    });
                }
            });
        }
    }
    return false;
}

(window as any).forgotPasswordClick = forgotPasswordClick;
(window as any).resetPasswordNew = resetPasswordNew;

//#endregion

if (!(window as any).initLogin)
{
    (window as any).initLogin = true;
    document.addEventListener("DOMContentLoaded", () =>
    {
        createPopup();
        initMagicLink();
    });
}

export const initMagicLink = () =>
{
    if ($(".js-magiclink .mail-option") && $(".js-magiclink .mail-option").length > 0)
    {
        if ($(".js-registerform").length > 0) {
            sendDataLayer({
                'event': 'Klantenmededelingen',
                'category': 'Klantenmededelingen',
                'action': document.location.pathname,
                'label': "Dit e-mailadres is reeds in gebruik"
            });
        }

        $(".js-magiclink .mail-option").off();

        $(".js-magiclink .mail-option").on("click", function ()
        {
            var eventType = 'Login';

            if ($(".registration-step1-content").length > 0)
                eventType = 'Registratie';

            sendDataLayer({
                'event': eventType,
                'category': eventType,
                'action': 'MagicLink'
            });

            $.ajax({
                type: "POST",
                url: "/Services/modules/Webshop.asmx/SendMagicLinkEmail",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                complete: function ()
                {
                    showNotification({ status: "success", message: getTranslations().txtcheckEmailForHelpWithLogin });
                    $(".js-magiclink .mail-option").remove();
                }
            });
        });

        $(".js-magiclink a, .js-magiclink a > .magiclink-button").on("click", function ()
        {
            var eventType = 'Login';

            if ($(".registration-step1-content").length > 0)
                eventType = 'Registratie';

            sendDataLayer({
                'event': eventType,
                'category': eventType,
                'action': 'Doorgaan zonder in te loggen'
            });
        });
    }
};

(window as any).initMagicLink = initMagicLink;
